import React, {
    useContext, useEffect, useMemo
} from 'react';
import htmlParser from 'html-react-parser';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import { SgPaymentUtils, useSgExpandableSection } from 'saga-modules';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import messages from './SgMonthlyDdi.messages';
import metadata from './SgMonthlyDdi.metadata.json';

function SgMonthlyDdi(props) {
    const {
        id,
        modelVM,
        updateData,
        showErrors,
        path,
        onValidate: onValidateParent,
    } = props;
    const {
        isComponentValid,
        onValidate
    } = useValidation(id);

    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'tablet' || breakpoint === 'phoneWide' || breakpoint === 'phone';
    const contactUsPhoneNumber = SgPaymentUtils.getProductPhoneNumberForDDI();
    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    const directDebitTextContent = useMemo(() => {
        return (
            <span>
                {translator(messages.DirectDebitText, {
                    phoneNumber: isMobile
                        ? <a href={`tel:${contactUsPhoneNumber.replaceAll(' ', '')}`}>{contactUsPhoneNumber}</a>
                        : contactUsPhoneNumber
                })}
            </span>
        );
    }, [translator, isMobile, contactUsPhoneNumber]);
    const getDdiSortCodeExpandableContent = useMemo(() => {
        return (
            <>
                <p>{translator(messages.SortCodeHelptextP1)}</p>
                <p>{translator(messages.SortCodeHelptextP2)}</p>
            </>
        );
    }, []);

    const ddiSortCodeExpandableSection = useSgExpandableSection({
        id: 'ddiSortCodeSection',
        content: getDdiSortCodeExpandableContent,
        showMoreLabel: htmlParser(`<i class="mir mi-chevron-right"></i> ${translator(messages.WhereWouldIFoundThis)}`),
        showLessLabel: htmlParser(`<i class="mir mi-expand-more"></i> ${translator(messages.WhereWouldIFoundThis)}`)
    });

    const getDdiAccountNumberExpandableContent = useMemo(() => {
        return (
            <>
                <p>{translator(messages.AccountNumberHelptextP1)}</p>
                <p>{translator(messages.AccountNumberHelptextP2)}</p>
            </>
        );
    }, []);

    const ddiAccountNumberExpandableSection = useSgExpandableSection({
        id: 'ddiAccountNumberSection',
        content: getDdiAccountNumberExpandableContent,
        showMoreLabel: htmlParser(`<i class="mir mi-chevron-right"></i> ${translator(messages.WhereWouldIFoundThis)}`),
        showLessLabel: htmlParser(`<i class="mir mi-expand-more"></i> ${translator(messages.WhereWouldIFoundThis)}`)
    });

    const overrideProps = {
        ddiAccountHolderName: {
            path: `${path}.accountHolderName_Ext`
        },
        ddiAccountNumber: {
            path: `${path}.bankAccountNumber`
        },
        ddiSortCode: {
            path: `${path}.sortCode_Ext`,
            onValueChange: (value) => {
                const copyModel = _.clone(modelVM);
                if (value) {
                    const sortCodeValue = SgPaymentUtils.getFormattedSortCodeValue(value);
                    _.set(copyModel, `${path}.sortCode_Ext.value`, sortCodeValue);
                } else {
                    _.set(copyModel, `${path}.sortCode_Ext.value`, undefined);
                }
                updateData(copyModel);
            }
        },
        DirectDebitText: {
            content: directDebitTextContent
        },
        ddiAccountNumberMoreInformationExtandableContent: {
            content: (<>{ddiAccountNumberExpandableSection}</>)
        },
        ddiSortCodeMoreInformationExtandableContent: {
            content: (<>{ddiSortCodeExpandableSection}</>)
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            showErrors={showErrors}
            onModelChange={updateData}
            onValidationChange={onValidate}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
        />

    );
}

export default SgMonthlyDdi;
